import React from 'react'
import { NavLink } from 'react-router-dom';
import { motion } from "framer-motion"

const Menu = ({ closeMenu }) => {

  return (
    <>
      <ul className='menu flex'>
          <motion.li
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}>
             <NavLink className='menu-item' activeclassname="active" to="/" onClick={closeMenu}>HOME</NavLink> 
          </motion.li>
          <motion.li
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}>
            <NavLink className='menu-item' activeclassname="active" to="/about" onClick={closeMenu}>ABOUT ME</NavLink>
          </motion.li>
          <motion.li
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.6 }} >
            <NavLink className='menu-item' activeclassname="active" to="/experience" onClick={closeMenu}>EXPERIENCE</NavLink> 
          </motion.li>
          <motion.li
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.8 }}>
            <NavLink className='menu-item' activeclassname="active" to="/projects" onClick={closeMenu}>PROJECTS</NavLink> 
          </motion.li>
          <motion.li
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 1 }}>
            <NavLink className='menu-item' activeclassname="active" to="/contact" onClick={closeMenu}>CONTACTS</NavLink> 
          </motion.li>
      </ul>
    </>
  )
}

export default Menu